import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CustomerHeader from "../components/CustomerHeader";
import CustomerFooter from "../components/CustomerFooter";
import "../App.css";

function About() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <CustomerHeader />

      {/* Main Content */}
      <div
        style={{
          padding: isMobile ? "40px 16px" : "80px 48px",
          paddingTop: isMobile ? "90px" : "130px",
          maxWidth: "900px",
          margin: "0 auto",
        }}
      >
        <h1
          style={{
            fontSize: isMobile ? "32px" : "48px",
            fontWeight: "700",
            color: "#1a1a1a",
            marginBottom: "24px",
            textAlign: "center",
          }}
        >
          About OGESTYLE
        </h1>

        <p
          style={{
            fontSize: isMobile ? "16px" : "20px",
            color: "#6b7280",
            marginBottom: "48px",
            textAlign: "center",
          }}
        >
          Connecting people with the best beauty and wellness professionals
        </p>

        <div
          style={{
            background: "white",
            border: "1px solid #e5e7eb",
            borderRadius: "12px",
            padding: isMobile ? "32px 20px" : "48px 40px",
            marginBottom: "48px",
          }}
        >
          <h2
            style={{
              fontSize: isMobile ? "24px" : "32px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "20px",
            }}
          >
            Our Mission
          </h2>
          <p
            style={{
              fontSize: isMobile ? "15px" : "18px",
              color: "#374151",
              lineHeight: "1.8",
              marginBottom: "24px",
            }}
          >
            OGESTYLE is your trusted platform for discovering and booking beauty
            and wellness services. We connect customers with verified
            professionals and businesses, making it easy to find, book, and
            enjoy quality services.
          </p>
          <p
            style={{
              fontSize: isMobile ? "15px" : "18px",
              color: "#374151",
              lineHeight: "1.8",
            }}
          >
            Whether you're looking for a fresh haircut, a relaxing spa day, or
            professional makeup services, OGESTYLE brings the best beauty
            professionals to your fingertips.
          </p>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
            gap: "24px",
            marginBottom: "48px",
          }}
        >
          <div
            style={{
              textAlign: "center",
              padding: "24px",
            }}
          >
            <div
              style={{
                fontSize: "48px",
                marginBottom: "16px",
              }}
            >
              ✨
            </div>
            <h3
              style={{
                fontSize: "20px",
                fontWeight: "600",
                color: "#1a1a1a",
                marginBottom: "8px",
              }}
            >
              Quality Service
            </h3>
            <p
              style={{
                fontSize: "14px",
                color: "#6b7280",
              }}
            >
              Verified professionals with ratings & reviews
            </p>
          </div>

          <div
            style={{
              textAlign: "center",
              padding: "24px",
            }}
          >
            <div
              style={{
                fontSize: "48px",
                marginBottom: "16px",
              }}
            >
              📅
            </div>
            <h3
              style={{
                fontSize: "20px",
                fontWeight: "600",
                color: "#1a1a1a",
                marginBottom: "8px",
              }}
            >
              Easy Booking
            </h3>
            <p
              style={{
                fontSize: "14px",
                color: "#6b7280",
              }}
            >
              Book appointments in just a few clicks
            </p>
          </div>

          <div
            style={{
              textAlign: "center",
              padding: "24px",
            }}
          >
            <div
              style={{
                fontSize: "48px",
                marginBottom: "16px",
              }}
            >
              🔒
            </div>
            <h3
              style={{
                fontSize: "20px",
                fontWeight: "600",
                color: "#1a1a1a",
                marginBottom: "8px",
              }}
            >
              Secure Payments
            </h3>
            <p
              style={{
                fontSize: "14px",
                color: "#6b7280",
              }}
            >
              Safe and secure payment processing
            </p>
          </div>
        </div>

        <div style={{ textAlign: "center" }}>
          <Link
            to="/"
            style={{
              display: "inline-block",
              background: "linear-gradient(135deg, #1a659e 0%, #2980b9 100%)",
              color: "white",
              padding: isMobile ? "12px 24px" : "14px 32px",
              borderRadius: "8px",
              textDecoration: "none",
              fontWeight: "600",
              fontSize: isMobile ? "14px" : "16px",
            }}
          >
            ← Back to Home
          </Link>
        </div>
      </div>
      <CustomerFooter />
    </>
  );
}

export default About;
